import ButtonTableAction from '../../../../components/buttons/ButtonTableAction';
import DefaultDataTable from '../../../../components/default/DefaultDataTable';
import { formatNumberWithDots } from '../../../../helpers';
import { DeductionRateFilters } from '../../../../app/models/DeductionRate';
import { BonusRateDataForm } from '../../../../app/models/BonusRate';

interface Props {
    bonusRates: BonusRateDataForm[];
    totalRows: number;
    loading?: boolean;
    edit?: (id: number) => void;
    active?: (id: number, active: boolean) => void;
    show?: (id: number) => void;
    destroy?: (id: number) => void;
    filter: DeductionRateFilters;
    setFilter: (filter: DeductionRateFilters) => void;
    paginationRowsPerPageOptions?: any[];
}

const DeductionRateDataTable = ({
    bonusRates,
    totalRows,
    loading = false,
    edit,
    active,
    show,
    destroy,
    filter,
    setFilter,
}: Props) => {

    const columns = [
        {
            name: 'Valor',
            selector: (row: any) => row.value,
            sortable: false,
            sortField: 'value',
            cell: (row: any, index: any, column: any) => {
                return (
                    <>
                        {row.bonus_type === "Fijo" ? (
                            <span className="">{formatNumberWithDots(row.value) + ' CLP'}</span>
                        ) : row.bonus_type === "Porcentaje" ? (
                            <span className="">
                                {row.value}
                            </span>
                        ) : null}
                    </>
                );
            }
        },
        {
            name: 'Tipo de bonificación',
            selector: (row: any) => row.bonus_type,
            sortable: false,
            sortField: 'bonus_type',
            cell: (row: any, index: any, column: any) => (
                <span className="">{row.bonus_type}</span>
            )
        },
        {
            name: 'Fecha de inicio',
            selector: (row: any) => row.valid_from,
            sortable: false,
            sortField: 'valid_from',
            cell: (row: any, index: any, column: any) => <span className="">{row.valid_from}</span>
        },
        {
            name: 'Fecha de fin',
            selector: (row: any) => row.valid_until,
            sortable: false,
            sortField: 'valid_until',
            cell: (row: any, index: any, column: any) => <span className="">{row.valid_until}</span>
        },
        {
            name: 'Imponible',
            selector: (row: any) => row.is_taxable,
            sortable: false,
            sortField: 'valid_until',
            cell: (row: any, index: any, column: any) => {
                return (
                    <>
                        {row.is_taxable ? (
                            <span className="">Sí</span>
                        ) : (
                            <span className="">No</span>
                        )}
                    </>
                );
            }
        },
        {
            name: 'Acciones',
            selector: (row: any) => row.id,
            sortable: false,
            cell: (row: any, index: any, column: any) => (
                <div className="">
                    {edit && (
                        <ButtonTableAction
                            callbackFunction={() => edit(row.id ?? -1)}
                            classIcon={'mdi mdi-pencil'}
                            colorIcon={'text-warning'}
                            errorMessage={'No se puede editar este registro.'}
                            title={'Editar'}
                        />
                    )}
                    {destroy && (
                        <ButtonTableAction
                            callbackFunction={() => destroy(row.id ?? -1)}
                            classIcon={'mdi mdi-delete'}
                            colorIcon={'text-danger'}
                            errorMessage={'No se puede eliminar este registro.'}
                            title={'Eliminar'}
                        />
                    )}
                </div>
            )
        }
    ];

    return (
        <div>
            <DefaultDataTable
                columns={columns}
                data={bonusRates}
                progressPending={loading}
                paginationTotalRows={totalRows}
                filter={filter}
                setFilter={setFilter}
            />
        </div>
    );
};

export default DeductionRateDataTable;
